var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3904 5.68767C13.5629 5.9033 13.528 6.21795 13.3123 6.39045L7.99998 10.6403L2.68763 6.39045C2.472 6.21795 2.43704 5.9033 2.60955 5.68767C2.78205 5.47204 3.0967 5.43708 3.31233 5.60958L7.99998 9.35971L12.6876 5.60958C12.9033 5.43708 13.2179 5.47204 13.3904 5.68767Z",
    fill: "#2D3958"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShevronDown);
export default __webpack_public_path__ + "static/media/shevron-down.4c2f7e4752e07181396c4a14643b8ce4.svg";
export { ForwardRef as ReactComponent };